// extracted by mini-css-extract-plugin
export default {"colLeft":"Statistics_colLeft__eKEeF","colRight":"Statistics_colRight__xcKUL","col":"Statistics_col__25INm","colXs":"Statistics_colXs__B-JXa"};